var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _path24, _path25, _path26, _g3, _path27, _path28, _path29, _path30, _g4, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _ellipse2, _ellipse3, _g5, _path39, _path40, _path41, _path42, _circle2, _path43, _path44, _rect, _rect2, _line, _g6, _g7, _g8, _g9, _g0, _rect3, _g1, _rect4, _g10, _circle3, _circle4, _circle5, _circle6, _circle7, _line2, _g11, _g12, _g13, _g14, _rect5, _rect6, _rect7, _rect8, _rect9, _g15, _g16, _g17, _g18, _g19, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9ddec34-9319-4b16-a09a-346676300955",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 971.7,
    height: 764.21,
    viewBox: "0 0 971.7 764.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7a49f6f8-cfb3-4a5a-81e0-f7f3caa92e45",
    x1: 897.38,
    y1: 799.91,
    x2: 897.38,
    y2: 380.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "53018405-060f-4bce-97d3-1ae9b44325c4",
    x1: 303.98,
    y1: 804.79,
    x2: 303.98,
    y2: 375.83,
    xlinkHref: "#7a49f6f8-cfb3-4a5a-81e0-f7f3caa92e45"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "data_report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M808.14,68c-3.81-.06-8.62,1-11.56,6.27-5.76,10.36,3.51,20.55-1.27,31.59a18.38,18.38,0,0,1-6.2,7.48c-4.62,3.33-9.33,4.32-14,6.31A25.66,25.66,0,0,0,762,131.35a30.62,30.62,0,0,0-2.76,18.57c.92,5.52,3.09,9.9,4.88,14.62a91.71,91.71,0,0,1,4.69,18.06,33.36,33.36,0,0,1,.46,8.72,54.91,54.91,0,0,1-2.69,10.89l-10.28,32.19a75.18,75.18,0,0,0-3.3,12.9,54.21,54.21,0,0,0,.4,13.75c1.12,9.42,2.37,19.22,6.83,25.11s13.21,6.27,19.61-2.08c6.09-8,7.66-20.1,13.24-28.8,8.79-13.72,22.85-12.53,32.27-25.38,9-12.32,8.86-30.1,14.51-45.26,4-10.86,11-20,15.72-30.55,6.81-15.21,8.37-32.29,6-45.77a67.93,67.93,0,0,0-15.15-32.09c-2.92-3.54-6.1-6.83-10.15-8-4.31-1.28-8.61,2-13.05,2.3C818.1,70.79,813.31,68.08,808.14,68Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#01bf71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.3,68.1s-24.8,143.65-66,222.08",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.3,74.93s30.26,31,18.68,73.84",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.63,134.52s53.25,21.22,46.21,45.34",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.74,108s-23.74,9.67-48.34,47.11",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825,230.05s-16.07,5.58-24.28-29",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.15,233.34s30.92,4.12,35.52-10",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.37,245.8c-2.14,3.16-3.9,7.75-1.1,13.1,5.5,10.5,19.1,8.34,25.71,18.39a18.38,18.38,0,0,1,2.85,9.29c.25,5.69-1.51,10.17-2.42,15.18A25.66,25.66,0,0,0,243,319.11a30.62,30.62,0,0,0,14,12.49c5.12,2.26,10,2.84,14.9,3.94a91.71,91.71,0,0,1,17.67,6,33.36,33.36,0,0,1,7.54,4.4,54.91,54.91,0,0,1,7.63,8.22l21.27,26.26a75.18,75.18,0,0,0,9,9.84,54.21,54.21,0,0,0,11.72,7.21c8.49,4.23,17.37,8.56,24.74,8.07s12.49-7.6,9-17.54c-3.3-9.46-12.6-17.43-16.82-26.87-6.65-14.88,2.06-26-3.51-40.9-5.34-14.32-20.31-23.92-29.87-37-6.86-9.34-10.68-20.16-16.91-29.91-9-14-22.4-24.71-35-30.13a67.93,67.93,0,0,0-35.15-4.94c-4.56.5-9.05,1.35-12.29,4.08-3.44,2.9-3,8.32-5.24,12.17C223.18,239,218.28,241.52,215.37,245.8Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#01bf71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,225.66S335.2,325.21,378.14,402.72",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.68,259.5s42.55-8.27,72,24.9",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.92,322s47-32.87,63.26-13.75",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,223s-4.95,25.16,12.86,66.26",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,320.61s-4.16,16.5-37.6,4.37",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.17,378.32s20.41-23.59,11.13-35.17",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.36,130.33c-5,5.91-9.68,14.09-6,22.16,7.14,15.81,33.33,8.1,42.68,22.84,2.8,4.41,3.18,9.8,2.53,14.61-1.26,9.41-5.92,17.4-9.14,26s-4.89,19-.35,28.08c4.37,8.79,13.58,14.34,22.5,16.55s17.86,1.71,26.77,2a148.2,148.2,0,0,1,31.35,4.62,43.31,43.31,0,0,1,12.82,5c4.55,2.91,8.23,7.18,11.83,11.38l32,37.29c4.25,5,8.59,10,13.86,13.67,6.08,4.23,13,6.38,19.81,8.45,14.65,4.48,30,9,44,5.93s25.75-16.45,22.25-31.94c-3.33-14.75-18.35-25.21-23.41-39.66-8-22.77,11.75-43.89,5.82-67.06-5.68-22.22-30.86-33.68-44.86-52.49-10-13.48-13.94-30.34-22.68-44.68-12.59-20.66-34.55-34.37-56.5-39.57S276.62,70.82,256.08,76c-8.7,2.21-17.4,5-24.3,10.52-7.33,5.87-8.18,14.77-13.52,21.86C212.07,116.64,202.1,122.32,195.36,130.33Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#01bf71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.51,92.73s169.67,133.5,226.76,249.56",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.9,153.36S272.27,126.68,317.45,173",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.7,248.3s98.11-69,122.91-42.09",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320.29,73.21s-16.91,43.39,4,106.46",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M444.34,211s-12.81,28.73-71.9,18.68",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.13,317.43s45.47-45.48,31.57-62",
    transform: "translate(-114.15 -67.9)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.85,
    cy: 723.13,
    rx: 485.85,
    ry: 41.08,
    fill: "#01bf71",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M977.18,467.14c-2.07-6.06-5.06-13.74-7.42-15.55a2.21,2.21,0,0,0-.47-.29H969v-7.49l-5.58.89a53.35,53.35,0,0,1-2-8.29,3.85,3.85,0,0,0,4.19.84c-.09-.15-.17-.31-.25-.47l.25-.11a10.37,10.37,0,0,1-1.35-5.08,18.51,18.51,0,0,1,.77-4.8c1-3.45,2.69-6.67,3.63-10.14a24.64,24.64,0,0,0,.84-6.85,25,25,0,0,0-2.6-11.3,6.6,6.6,0,0,0-2-2.58,25.49,25.49,0,0,0-2.42-1.18,13.07,13.07,0,0,1-3.52-3.51,31.56,31.56,0,0,0-15.25-10.18,8.93,8.93,0,0,0-4.88-.39c-3.75,1-5.11,5.65-8.15,8.09-2.68,2.15-6.36,2.37-9.73,3.09s-6.76,2.15-9.06,4.75a9.83,9.83,0,0,0-2.43,6.55,6.59,6.59,0,0,0,2.68,5.86,8.42,8.42,0,0,0,7.11,1,24.18,24.18,0,0,0,18.31,30.4l.65,1.17h0a50.08,50.08,0,0,1,4.54,11.85c-5.14,2.91-10.75,5.64-14.14,5.9a23.82,23.82,0,0,1-.74,3.92,21.62,21.62,0,0,1-4.45,8.75c-4.61,5.18-25.34,44.34-25.34,44.34s-.65,1.56-1.72,4.22c-12.87,1.58-33.88,3.86-39.74,2.69l-23-21.88s-7.44,5.68-6.79,12.58L822.74,510s-21.88,16.7,12.67,27.64l52.57,6.1c-5,15.11-9.68,32.7-8.23,42.27h.43a19.88,19.88,0,0,0,3-.23l-.09,1.7L878,678.17s-1.15,16.7,14.4,24.18c0,0,19,55.85,11.52,62.19,0,0,.89.47,2.39,1.12l-15.63,13.85s-11.52,2.88-17.85,2.3a4.57,4.57,0,0,0-5.05,3.4c0,.12,0,.24-.06.36l0,.15c0,.12,0,.24,0,.37s0,.09,0,.14,0,.21,0,.32,0,.09,0,.13,0,.25.07.37l0,.14q.05.2.13.4l.05.12c.05.13.11.26.18.39l0,.09c.07.13.15.25.23.38l.07.11q.14.2.31.4l.09.1c.12.14.25.27.38.4l.06.05.43.37.09.07c.16.13.34.25.52.37l.12.08c.19.12.39.24.6.35l.09,0,.65.32.09,0,.76.3.16.06.83.27.14,0,.91.24.07,0,1,.2.2,0,1.08.16.21,0,1.22.12c2.37.18,5.56.25,9.25.23h0s0,.09,0,.14,0,.21,0,.32l0,.13c0,.12,0,.25.07.37l0,.14q.05.2.13.4l.05.12c.05.13.11.26.18.39l0,.09c.07.13.15.25.23.38l.07.11q.14.2.31.4l.09.1c.12.14.25.27.38.4l.06.05.43.37.09.07c.16.13.34.25.52.37l.13.08c.19.12.39.24.6.35l.09,0,.65.32.09,0,.76.3.16.06.83.27.14,0,.91.24.07,0,1,.2.2,0,1.08.16.21,0,1.22.12c15,1.15,62.76-2.3,62.76-2.3l0-.13v0l0-.17v0c.47-2.23,2.77-15.19-5.39-24.77.24-.25.48-.52.7-.8,0,0-6.33-10.94-2.88-14.4s-17.27-63.34-17.27-63.34-10.94-17.27-4.61-36.85-.58-40.88-.58-40.88,15.1-4.49,15.41-23.08c0-.56,0-1.14,0-1.73a6.11,6.11,0,0,0,1,.06,4.47,4.47,0,0,0,.64,0s-2.88-10.36.58-17.85,10.94-.58,17.85-31.09c5-22.08,9.4-47.48,11.45-59.84A31.51,31.51,0,0,0,977.18,467.14ZM845.77,531.92l-5.25-5c1.74.72,3.67,1.43,5.83,2.11l19.8,2.3C857.31,532.13,849.1,532.58,845.77,531.92Z",
    transform: "translate(-114.15 -67.9)",
    fill: "url(#7a49f6f8-cfb3-4a5a-81e0-f7f3caa92e45)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M895.89,529s-40.73,5.66-49.22,4L824,511.44s-21.5,16.41,12.45,27.15L899.85,546Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#fdc2cc"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M895.89,529s-40.73,5.66-49.22,4L824,511.44s-21.5,16.41,12.45,27.15L899.85,546Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.05
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M910.6,758.65l-19.8,17.54s-11.31,2.83-17.54,2.26-9.05,9.62,5.66,10.75,61.66-2.26,61.66-2.26,4.53-18.1-9.05-28.29Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#47465a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M910.6,758.65l-19.8,17.54s-11.31,2.83-17.54,2.26-9.05,9.62,5.66,10.75,61.66-2.26,61.66-2.26,4.53-18.1-9.05-28.29Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M941.29,779.11a31.2,31.2,0,0,1-.71,6.13s-47,3.39-61.66,2.26c-7.07-.54-10.08-3.18-10.62-5.71-.64,2.9,1.92,6.74,10.62,7.41,14.71,1.13,61.66-2.26,61.66-2.26A32.69,32.69,0,0,0,941.29,779.11Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#fff",
    opacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M933.79,437.9s12.45,17.54,7.92,29.42,23.76-12.45,23.76-12.45-9.05-15.84-4.53-32.81Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#fdc2cc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M930.4,765.44,910.6,783s-11.31,2.83-17.54,2.26S884,794.86,898.72,796s61.66-2.26,61.66-2.26,4.53-18.1-9.05-28.29Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#47465a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M936.06,761.48c-2.95,3.64-7.11,5-11.46,5.25-9.89.47-20.78-5.25-20.78-5.25,7.35-6.22-11.31-61.1-11.31-61.1-15.27-7.35-14.14-23.76-14.14-23.76l5-89.07,1.25-22.37,15.84-9.62,12.49,9.58,11.84,9.09a47.6,47.6,0,0,1,1.48,8.83c1.37,20.79-15.06,25.68-15.06,25.68s6.79,20.93.57,40.16,4.53,36.2,4.53,36.2,20.37,58.83,17,62.23S936.06,761.48,936.06,761.48Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#565171"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M936.06,761.48c-2.95,3.64-7.11,5-11.46,5.25-9.89.47-20.78-5.25-20.78-5.25,7.35-6.22-11.31-61.1-11.31-61.1-15.27-7.35-14.14-23.76-14.14-23.76l5-89.07,1.25-22.37,15.84-9.62,12.49,9.58,11.84,9.09a47.6,47.6,0,0,1,1.48,8.83c1.37,20.79-15.06,25.68-15.06,25.68s6.79,20.93.57,40.16,4.53,36.2,4.53,36.2,20.37,58.83,17,62.23S936.06,761.48,936.06,761.48Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.05
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M955.86,768.27c-9.62,11.88-32.24,0-32.24,0a3.6,3.6,0,0,0,1-1.54c4.15-11.28-14-65.21-14-65.21-15.27-7.35-17-24.89-17-24.89l-4-90.65-.52-11.74,23.8-9.09,7.31-2.79L944.54,581a44.12,44.12,0,0,1,1.56,11.83C945.8,611.12,931,615.53,931,615.53s6.79,20.93.57,40.16,4.53,36.2,4.53,36.2,20.37,58.83,17,62.23S955.86,768.27,955.86,768.27Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#565171"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M946.1,592.85c-4.89-.7-14.79-6.59-19.88-9.79-1.94-1.22-3.18-2-3.18-2s-5.09-14.14-18.67-3.39A50.82,50.82,0,0,1,889.62,586a34.51,34.51,0,0,1-6.3,1.58l1.25-22.37,15.84-9.62,12.49,9.58,7.31-2.79L944.54,581A44.12,44.12,0,0,1,946.1,592.85Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M976.72,484.33c-2,12.14-6.34,37.09-11.25,58.79-6.79,30-14.14,23.19-17.54,30.55s-.57,17.54-.57,17.54c-5.66.57-24.33-11.88-24.33-11.88s-5.09-14.14-18.67-3.39-24.33,10.18-24.33,10.18c-2.83-18.67,18.1-68.45,18.1-68.45S918.52,479.2,923,474.11a21.24,21.24,0,0,0,4.37-8.6,23.4,23.4,0,0,0,.72-3.85c7.35-.57,25.46-13,25.46-13l14.14-2.26v7.35a2.17,2.17,0,0,1,.46.28c2.33,1.78,5.26,9.33,7.29,15.28A31,31,0,0,1,976.72,484.33Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#f68080"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M965.47,461.1s-14.71-11.88-36.77,26.59-27.15,32.24-27.15,32.24,4.53,17,2.26,20.37c0,0,15.27-1.13,20.93,0s40.73-43,40.73-43S983.58,472.41,965.47,461.1Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M964.91,458.83S950.2,447,928.14,485.42,901,517.67,901,517.67,918.52,536.9,924.18,538s40.73-43,40.73-43S983,470.15,964.91,458.83Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M903.29,536.62c.23-4.19-1.35-11.56-2.26-15.38,3.44-.45,5.61-.75,5.61-.75l4,17Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M961.51,423.19,934.36,439a58,58,0,0,1,3.16,5.18,23.87,23.87,0,0,0,4.76.48c7.25,0,10.63-7.61,15-12.73C957,427.85,960.3,427.75,961.51,423.19Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 827.57,
    cy: 351.9,
    r: 23.76,
    fill: "#fdc2cc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M911.66,400.58a16.24,16.24,0,0,1,8.9-4.67c3.3-.71,6.92-.93,9.56-3,3-2.39,4.32-6.93,8-7.94a8.77,8.77,0,0,1,4.79.38,31,31,0,0,1,15,10,12.84,12.84,0,0,0,3.45,3.45,25,25,0,0,1,2.38,1.16,6.48,6.48,0,0,1,1.94,2.53,24.59,24.59,0,0,1,1.72,17.27c-.92,3.41-2.58,6.57-3.56,10s-1.23,7.24.57,10.27c-1.74.89-3.94-.23-5-1.85s-1.42-3.62-2-5.49a21,21,0,0,0-6.13-9.53c-1.78-1.58-5-2.64-6.21-.6-.48.79-.45,1.79-.86,2.61-.81,1.6-3.15,1.92-4.7,1a7.21,7.21,0,0,1-2.94-4.36c-2.33-7.88-6.3-12.84-14.73-9.47-3.14,1.26-6.84,2.11-9.86-.05C908,409.44,908.81,403.8,911.66,400.58Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M911.66,400a16.24,16.24,0,0,1,8.9-4.67c3.3-.71,6.92-.93,9.56-3,3-2.39,4.32-6.93,8-7.94a8.77,8.77,0,0,1,4.79.38,31,31,0,0,1,15,10,12.84,12.84,0,0,0,3.45,3.45,25,25,0,0,1,2.38,1.16,6.48,6.48,0,0,1,1.94,2.53,24.59,24.59,0,0,1,1.72,17.27c-.92,3.41-2.58,6.57-3.56,10s-1.23,7.24.57,10.27c-1.74.89-3.94-.23-5-1.85s-1.42-3.62-2-5.49a21,21,0,0,0-6.13-9.53c-1.78-1.58-5-2.64-6.21-.6-.48.79-.45,1.79-.86,2.61-.81,1.6-3.15,1.92-4.7,1a7.21,7.21,0,0,1-2.94-4.36c-2.33-7.88-6.3-12.84-14.73-9.47-3.14,1.26-6.84,2.11-9.86-.05C908,408.87,908.81,403.24,911.66,400Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#b96b6b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M968.2,454h-11.5s-22.63,11.31-23.19,10.75c-.38-.38-3.88.27-6.1.74a23.4,23.4,0,0,0,.72-3.85c7.35-.57,25.46-13,25.46-13l14.14-2.26v7.35A2.17,2.17,0,0,1,968.2,454Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.05
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M961.09,785.9a31.2,31.2,0,0,1-.71,6.13s-47,3.39-61.66,2.26c-7.07-.54-10.08-3.18-10.62-5.71-.64,2.9,1.92,6.74,10.62,7.41,14.71,1.13,61.66-2.26,61.66-2.26A32.69,32.69,0,0,0,961.09,785.9Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#fff",
    opacity: 0.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M899,575.37c-7.63,6-14.38,8.51-18.81,9.51,0,.42.08.84.14,1.24,0,0,10.75.57,24.33-10.18a18.23,18.23,0,0,1,7.27-3.8C909,570.73,904.74,570.82,899,575.37Z",
    transform: "translate(-114.15 -67.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.77,469.3c-2-6-5-13.5-7.29-15.28a2.17,2.17,0,0,0-.46-.28s-4.68.16-4.53.28c2.33,1.78,4.59,8.76,6.62,14.71a31,31,0,0,1,1.23,15c-2,12.14-6.34,37.09-11.25,58.79-6.79,30-14.14,23.19-17.54,30.55-2.78,6-1.39,13.94-.79,16.61,2.42,1,4.52,1.63,5.88,1.49,0,0-2.83-10.18.57-17.54s10.75-.57,17.54-30.55c4.91-21.69,9.23-46.65,11.25-58.79A31,31,0,0,0,975.77,469.3Z",
    transform: "translate(-114.15 -67.9)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M398.36,783.8s-13,.9-21.1-13a46.72,46.72,0,0,0-5.54-7.87,26.6,26.6,0,0,1-3.89-14.13c.45-10.32-10.32-66.88-10.32-66.88s1.35-21.55-9.43-35c-7.09-8.86-17.29-34.26-23.44-50.58a3.39,3.39,0,0,0,1.45.76l-.25-1.41.25.06-3.14-17.51a79.68,79.68,0,0,1-11.6-17.59l.72-.15,9.53-2s15.49-22,16.44-32.84l1.26.06h1.78c19.71-.43,42.91,2.25,42.91,2.25v0c0-.07-.11-.35-.23-.79h0a53.85,53.85,0,0,1-1.39-6.63l.89-.06,8.82-.59s30.52-34.11,19.3-40.4-22.89,28.28-22.89,28.28l-3.77.69-1,.19c.1-.15.2-.29.32-.43s-49.83-2.24-57.46-14.36c0,0-22-17.51-22.89-29.18-.48-6.19-4.36-9.48-7.91-11.2a17.26,17.26,0,0,0-8.72-1.63l-10.3.71.73,1.3-.29,0a34.65,34.65,0,0,1-1.62-4.56l.21,0c-.07-.32-.14-.64-.2-1a24.24,24.24,0,0,0,17.85-29.85,9.7,9.7,0,0,0,3-.08c3.78-.78,6.47-4.62,6.57-8.48,0-.25,0-.5,0-.75,0,0,0-.1,0-.15a13,13,0,0,0-5-10c-2.06-1.71-4.51-2.93-6.38-4.83-2.22-2.27-3.43-5.31-5.16-8a23.69,23.69,0,0,0-12.16-9.47c-3.72-1.26-8.27-1.4-11.12,1.3-1.47,1.39-2.32,3.38-4,4.55-2.37,1.69-5.59,1.19-8.49,1.53-5.26.62-9.88,4.37-12.2,9.14a21,21,0,0,0-2,9.65,25.79,25.79,0,0,0,.81,6.78c.56,2.21,1.39,4.34,2,6.53,1.26,4.56,1.55,9.36,3,13.87a17.45,17.45,0,0,0,5.62,8.52l-.43,1.86c-.28.06-7.27,1.56-12.11,12.12-3.82,8.32-16.74,16.92-22.42,20.39a9.35,9.35,0,0,0-4.23,5.87,30.53,30.53,0,0,0-.72,7.46c-.1,5.41,1,12.89,5.38,22.38,9.88,21.55,17.06,31,17.06,31s.55,6.6.58,13.56c0,5.18-.38,10.34-1.48,12.92-.93,2.18-1.22,7.75-1.2,14.1,0,12.19,1.2,28.1,1.2,28.1s3.43.65,8.75,1.43l3.31,58.19a28,28,0,0,1-6.33,19.44,43,43,0,0,1-8,7.58c-9.43,6.73-29.63,77.66-29.63,77.66s1,.06,2.62.19l-6.21,17.32s24.8,19,39.9,13.81a14.62,14.62,0,0,1,5-.71c3,0,9.35-2.35,5.8-5.46-6.45-5.64-14.18-14.18-19.35-20.12a10.29,10.29,0,0,1,1.4.82v-.14l.21.14s.05-.7.16-1.83l-.22-.07c.46-4.67,1.9-16.41,4.77-17.85,3.59-1.8,30.07-54.31,30.07-54.31l26.48-68.23s21.1,36.36,39.05,42.64V694s9.88,44.89,13.47,49.83,0,24.69,0,24.69a12.3,12.3,0,0,0,2.42,2.13l-2.87,16.27s20.65-.9,55.66,9.88C396.11,796.82,409.58,791,398.36,783.8ZM315.76,549l-4.37,1.09-.86.22c-.09-.54-.15-.86-.15-.86a8.92,8.92,0,0,1-3.17.77,58.47,58.47,0,0,1-2.66-15.14s-2.54-10.37-2.68-18.75c.05-3.27.54-6.12,1.78-7.73l1.46.12,1,1,.07.07.52.47h0l.54.49.09.08.59.51.1.09.6.51.06.05.67.55.15.12.71.57.06,0,.7.55.16.12.77.59.16.12.74.54.13.09.84.6.2.14.88.61.08.05.86.57.21.14.93.59.2.12.87.53.16.1,1,.58.24.14,1,.58.08,0,1,.53.25.13,1.06.53.22.1,1,.46.19.09,1.11.48.27.11,1.16.46h0C319.44,530.67,315.76,549,315.76,549Z",
    transform: "translate(-114.15 -67.9)",
    fill: "url(#53018405-060f-4bce-97d3-1ae9b44325c4)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.05,762.12l-8.33,23.23s22.81,17.49,37.63,13.87a41.42,41.42,0,0,1,6.8-1.1c3.07-.23,8.35-2.46,5.09-5.31-10.52-9.2-24.54-26.29-24.54-26.29Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#4f4d59"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M343.53,759.92l-3.94,22.35s20.16-.88,54.34,9.64c0,0,13.15-5.7,2.19-12.71,0,0-12.71.88-20.6-12.71s-12.71-11.83-12.71-11.83Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#4f4d59"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M239.23,597.78l3.86,68a28.13,28.13,0,0,1-6.71,19.89,41.23,41.23,0,0,1-7.24,6.75c-9.2,6.57-28.92,75.81-28.92,75.81s22.35,1.31,28.48,5.7c0,0,1.31-17.53,4.82-19.28s29.36-53,29.36-53L288.75,635s20.6,35.5,38.13,41.63v14.9s9.64,43.82,13.15,48.64,0,24.1,0,24.1,10.08,12.71,33.3-.88c0,0-7.45-8.33-7-18.41s-10.08-65.29-10.08-65.29,1.31-21-9.2-34.18S319,582,319,582l-12.06-25.95Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#787c9c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.39,768.25s19.72-69.24,28.92-75.81a41.75,41.75,0,0,0,7.61-7.19,27.81,27.81,0,0,0,6.33-19.44l-3.86-68L308,557.95l-.88-1.89-67.69,41.72,3.86,68A27.81,27.81,0,0,1,237,685.24a41.75,41.75,0,0,1-7.61,7.19c-9.2,6.57-28.92,75.81-28.92,75.81s22.35,1.31,28.48,5.7c0,0,.05-.68.16-1.79C220.47,769.2,204.39,768.25,204.39,768.25Z",
    transform: "translate(-114.15 -67.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.19,764.31s3.51-19.28,0-24.1S331,691.56,331,691.56v-14.9C313.51,670.53,292.91,635,292.91,635L291.38,639c5.94,9.42,21.79,32.81,35.71,37.68v14.9s9.64,43.82,13.15,48.64,0,24.1,0,24.1,4.89,6.15,15.69,5.32C347.88,769,344.19,764.31,344.19,764.31Z",
    transform: "translate(-114.15 -67.9)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M390,521.53l-8.61.57-4.54.3v-11l6-1.08,3.69-.67s11.39-33.74,22.35-27.61S390,521.53,390,521.53Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#714b4f"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M251.94,431.26s-5.7,21.91-7.45,35.5,40.75,2.63,40.75,2.63-16.21-19.72-7-30.24Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#714b4f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M298,522.41l.88,8.33-13.58-.88L271.66,518,258.08,479.9l-8.76-13.58L242.74,458l2.63-10.08s1.2,1,3.23,2.6c6.67,5.11,22.33,15.72,33.77,12.79a13.64,13.64,0,0,0,1.56-.49L301,492.17Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#e6e6f0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M248.87,445.28s-7,1.31-11.83,11.83c-3.71,8.09-16.22,16.43-21.81,19.86a9.35,9.35,0,0,0-4.24,5.91c-1.13,5-1.56,14.3,4.58,27.7,9.64,21,16.65,30.24,16.65,30.24s1.75,21-.88,27.17,0,39.88,0,39.88,46,8.76,61.35,0,13.15-42.51,13.15-42.51S320.3,596,325.56,596.91l-3.07-17.09s-17.09-18.41-18-42.07c0,0-5.26-21.47-.88-27.17,0,0,74.06,6.14,78.44.88,0,0-48.64-2.19-56.09-14,0,0-21.47-17.09-22.35-28.48a12.6,12.6,0,0,0-6.57-10.32,17.16,17.16,0,0,0-9.82-2.19l-9.9.68s17.09,30.24,16.21,34.18.88,35.93.88,35.93S274.73,484.72,266,479.9s-18.84-24.61-18.84-24.61l1.75-10",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298,522.41l.88,8.33-13.58-.88L271.66,518,258.08,479.9l-8.76-13.58L242.74,458l2.63-10.08s1.2,1,3.23,2.6L248,454s10.08,19.79,18.84,24.61,28.48,47.33,28.48,47.33-1.75-32-.88-35.93c.6-2.68-7.08-17.45-12.07-26.68a13.64,13.64,0,0,0,1.56-.49L301,492.17Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M381.37,522.11l-4.54.3v-11l6-1.08C380.72,513.12,380.79,518,381.37,522.11Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M248.87,444s-7,1.31-11.83,11.83c-3.71,8.09-16.22,16.43-21.81,19.86a9.35,9.35,0,0,0-4.24,5.91c-1.13,5-1.56,14.3,4.58,27.7,9.64,21,16.65,30.24,16.65,30.24s1.75,21-.88,27.17,0,39.88,0,39.88,46,8.76,61.35,0S305.84,564,305.84,564s14.46,30.68,19.72,31.55l-3.07-17.09s-17.09-18.41-18-42.07c0,0-5.26-21.47-.88-27.17,0,0,17.09,18.41,36.37,18s42.07,2.19,42.07,2.19-4.38-14,0-19.28c0,0-48.64-2.19-56.09-14,0,0-21.47-17.09-22.35-28.48a12.6,12.6,0,0,0-6.57-10.32,17.16,17.16,0,0,0-9.82-2.19l-9.9.68S294.45,486,293.57,490s.88,35.93.88,35.93S274.73,483.41,266,478.59,247.12,454,247.12,454l1.75-10",
    transform: "translate(-114.15 -67.9)",
    fill: "#787c9c"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M239.23,490s10.52,35.5,16.65,39.88,43.38,26.73,54.34,21.47c0,0,2.63,13.15-1.31,16.21,0,0-40.86-1.6-41.19-1.75,0,0-26.73-3.51-31.11-16.65s-9.64-35.5-9.64-35.5Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.18,
    cy: 459.99,
    rx: 1.53,
    ry: 2.19,
    fill: "#ba7855"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.56,
    cy: 475.33,
    rx: 1.53,
    ry: 2.19,
    fill: "#ba7855"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.41,606.11s-2.63-33.74,0-39.88.88-27.17.88-27.17-7-9.2-16.65-30.24c-6.14-13.4-5.7-22.7-4.58-27.7a9.35,9.35,0,0,1,4.25-5.91c5.59-3.43,18.1-11.77,21.8-19.86,2.72-5.93,6.13-8.94,8.6-10.43l.17-1s-7,1.31-11.83,11.83c-3.71,8.09-16.22,16.43-21.8,19.86a9.35,9.35,0,0,0-4.25,5.91c-1.13,5-1.56,14.3,4.58,27.7,9.64,21,16.65,30.24,16.65,30.24s1.75,21-.88,27.17,0,39.88,0,39.88,32.87,6.26,52.31,2.91C264,611.75,234.41,606.11,234.41,606.11Z",
    transform: "translate(-114.15 -67.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.57,490c-.6,2.7,0,18.58.49,28.3,2.12,4.33,3.45,7.19,3.45,7.19s-1.75-32-.88-35.93c.83-3.75-14.56-31.25-16.09-34l-3.19.22S294.45,486,293.57,490Z",
    transform: "translate(-114.15 -67.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.09,526.79c-19.28.44-36.37-18-36.37-18a7,7,0,0,0-1.11,2.38c5,4.71,19,16.38,34.41,16,19.28-.44,42.07,2.19,42.07,2.19s-.09-.29-.23-.79A348.85,348.85,0,0,0,343.09,526.79Z",
    transform: "translate(-114.15 -67.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.91,563.6s.18,2.74.08,6.85c4.56,9,12.86,24.52,16.57,25.14l-.65-3.6C318.51,584,308.91,563.6,308.91,563.6Z",
    transform: "translate(-114.15 -67.9)"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M321.18,559.22l-9.31,2-7.34,1.55,3.94-11,2.74-.69,4.27-1.06s6.14-30.68,18.41-28.48S321.18,559.22,321.18,559.22Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#714b4f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M311.87,561.18l-7.34,1.55,3.94-11,2.74-.69A43.77,43.77,0,0,1,311.87,561.18Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M239.23,489.1s10.52,35.5,16.65,39.88,43.38,26.73,54.34,21.47c0,0,2.63,13.15-1.31,16.21,0,0-40.86-1.6-41.19-1.75,0,0-26.73-3.51-31.11-16.65s-9.64-35.5-9.64-35.5Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#787c9c"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M252.38,432.14s-.89,3.43-2.08,8.42a23.65,23.65,0,0,0,26.12,12c-1.05-4.5-.82-9,2.26-12.57Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.64,
    cy: 360.73,
    r: 23.66,
    fill: "#714b4f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M291.33,422.12a12.67,12.67,0,0,0,5.28.32c3.69-.76,6.32-4.51,6.41-8.28a12.72,12.72,0,0,0-4.88-9.77c-2-1.67-4.4-2.86-6.23-4.72-2.17-2.21-3.35-5.19-5-7.79A23.13,23.13,0,0,0,275,382.64c-3.63-1.23-8.07-1.37-10.86,1.27-1.43,1.35-2.27,3.3-3.87,4.44-2.32,1.65-5.46,1.16-8.29,1.49a15.8,15.8,0,0,0-11.91,8.92,22.32,22.32,0,0,0-1.16,15.16c.55,2.15,1.35,4.24,1.94,6.38,1.23,4.46,1.52,9.14,2.94,13.54s4.35,8.7,8.78,10a27.76,27.76,0,0,1,2.82-14.3,4.1,4.1,0,0,1,2-2.22,4.85,4.85,0,0,1,2.41,0,24,24,0,0,0,16-3.24c1.68-1,4.3-4.51,6.1-4.86C284.2,418.81,288.93,421.58,291.33,422.12Z",
    transform: "translate(-114.15 -67.9)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M291.33,421.24a12.67,12.67,0,0,0,5.28.32c3.69-.76,6.32-4.51,6.41-8.28a12.72,12.72,0,0,0-4.88-9.77c-2-1.67-4.4-2.86-6.23-4.72-2.17-2.21-3.35-5.19-5-7.79A23.13,23.13,0,0,0,275,381.76c-3.63-1.23-8.07-1.37-10.86,1.27-1.43,1.35-2.27,3.3-3.87,4.44-2.32,1.65-5.46,1.16-8.29,1.49a15.8,15.8,0,0,0-11.91,8.92A22.32,22.32,0,0,0,238.91,413c.55,2.15,1.35,4.24,1.94,6.38,1.23,4.46,1.52,9.14,2.94,13.54s4.35,8.7,8.78,10a27.76,27.76,0,0,1,2.82-14.3,4.1,4.1,0,0,1,2-2.22,4.85,4.85,0,0,1,2.41,0,24,24,0,0,0,16-3.24c1.68-1,4.3-4.51,6.1-4.86C284.2,417.93,288.93,420.71,291.33,421.24Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#503f43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 226.33,
    y: 107.84,
    width: 516.75,
    height: 618,
    fill: "#fafbfc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 226.33,
    y: 107.84,
    width: 516.75,
    height: 20.95,
    fill: "#7983a6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 359.67,
    x2: 673.25,
    y2: 359.67,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 318.64,
    x2: 302.16,
    y2: 318.64,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 318.64,
    x2: 661.36,
    y2: 318.64,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 318.64,
    x2: 673.25,
    y2: 318.64,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 277.62,
    x2: 302.16,
    y2: 277.62,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 277.62,
    x2: 661.36,
    y2: 277.62,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 277.62,
    x2: 673.25,
    y2: 277.62,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 236.59,
    x2: 302.16,
    y2: 236.59,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 236.59,
    x2: 661.36,
    y2: 236.59,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 236.59,
    x2: 673.25,
    y2: 236.59,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 195.57,
    x2: 302.16,
    y2: 195.57,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 195.57,
    x2: 661.36,
    y2: 195.57,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 195.57,
    x2: 673.25,
    y2: 195.57,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.93,
    y: 277.62,
    width: 27.06,
    height: 82.05,
    fill: "#01bf71"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 390.43,
    y: 236.15,
    width: 27.06,
    height: 123.95,
    fill: "#01bf71"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.94,
    y: 318.2,
    width: 27.06,
    height: 42.33,
    fill: "#01bf71"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 541.44,
    y: 194.26,
    width: 27.06,
    height: 165.85,
    fill: "#01bf71"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.94,
    y: 234.41,
    width: 27.06,
    height: 125.26,
    fill: "#01bf71"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.46,
    cy: 378.43,
    r: 6.98,
    fill: "#01bf71"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.4,
    cy: 378.43,
    r: 6.98,
    fill: "#01bf71"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.34,
    cy: 378.43,
    r: 6.98,
    fill: "#01bf71"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.28,
    cy: 378.43,
    r: 6.98,
    fill: "#01bf71"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.22,
    cy: 378.43,
    r: 6.98,
    fill: "#01bf71"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 623.28,
    x2: 673.25,
    y2: 623.28,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 582.25,
    x2: 302.16,
    y2: 582.25,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 582.25,
    x2: 661.36,
    y2: 582.25,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 582.25,
    x2: 673.25,
    y2: 582.25,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 541.23,
    x2: 302.16,
    y2: 541.23,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 541.23,
    x2: 661.36,
    y2: 541.23,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 541.23,
    x2: 673.25,
    y2: 541.23,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 500.2,
    x2: 302.16,
    y2: 500.2,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 500.2,
    x2: 661.36,
    y2: 500.2,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 500.2,
    x2: 673.25,
    y2: 500.2,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 296.16,
    y1: 459.18,
    x2: 302.16,
    y2: 459.18,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 459.18,
    x2: 661.36,
    y2: 459.18,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10,
    strokeDasharray: "11.78 11.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.25,
    y1: 459.18,
    x2: 673.25,
    y2: 459.18,
    fill: "none",
    stroke: "#7983a6",
    strokeMiterlimit: 10
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 314.93,
    y: 541.23,
    width: 27.06,
    height: 82.05,
    fill: "#01bf71"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 390.43,
    y: 540.79,
    width: 27.06,
    height: 82.92,
    fill: "#01bf71"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 465.94,
    y: 581.82,
    width: 27.06,
    height: 42.33,
    fill: "#01bf71"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 541.44,
    y: 457.87,
    width: 27.06,
    height: 165.85,
    fill: "#01bf71"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 719.94,
    y: 360.02,
    width: 27.06,
    height: 125.26,
    fill: "#01bf71"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328.46,
    cy: 642.04,
    r: 6.98,
    fill: "#01bf71"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 404.4,
    cy: 642.04,
    r: 6.98,
    fill: "#01bf71"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 480.34,
    cy: 642.04,
    r: 6.98,
    fill: "#01bf71"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 556.28,
    cy: 642.04,
    r: 6.98,
    fill: "#01bf71"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 632.22,
    cy: 642.04,
    r: 6.98,
    fill: "#01bf71"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M302.2,791.48a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82h14.65A40.83,40.83,0,0,0,302.2,791.48Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#01bf71"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.2,779.48a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82h14.65A40.83,40.83,0,0,0,1014.2,779.48Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#01bf71"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M910.6,537.46l-7.31-.85-56-6.51C813.3,519.36,834.8,503,834.8,503l22.63,21.5c6.53,1.31,32.13-1.74,43.6-3.21,3.44-.45,5.61-.75,5.61-.75Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#fdc2cc"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M965.47,460s-14.71-11.88-36.77,26.59-27.15,32.24-27.15,32.24,4.53,17,2.26,20.37c0,0,15.27-1.13,20.93,0s40.73-43,40.73-43S983.58,471.28,965.47,460Z",
    transform: "translate(-114.15 -67.9)",
    fill: "#f68080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg-2.b8e417785e2f2402ede1cb79a71f5e6f.svg";
export { ForwardRef as ReactComponent };